import script from "./ScriptValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScriptValue.vue?vue&type=script&setup=true&lang=ts"

import "./ScriptValue.vue?vue&type=style&index=0&id=47687368&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47687368"]])

export default __exports__